// extracted by mini-css-extract-plugin
export default {"sideBanner":"AsideBanner_sideBanner__TvtkB"};